var exports = {
  "iE": "xaee3c4fa--2774dd--wrapper",
  "o5": "xaee3c4fa--2774dd--content-wrapper",
  "$U": "xaee3c4fa--2774dd--headnote",
  "nb": "xaee3c4fa--2774dd--status-wrapper",
  "DD": "xaee3c4fa--2774dd--title",
  "VA": "xaee3c4fa--2774dd--subtitle",
  "kZ": "xaee3c4fa--2774dd--image-wrapper",
  "Sl": "xaee3c4fa--2774dd--image",
};

module.exports = exports;
